import { itx } from "../../translationItx/itx";

export default function getFloorOptionsList(): Array<string> {
  return [
    itx("step1.basement", "Untergeschoss"),
    itx("step1.groundFloor", "Erdgeschoss"),
    itx("step1.upperFloor", "Obergeschoss"),
    itx("step1.attic", "Dachgeschoss"),
  ];
}
